import { render } from "./GastronomyList.vue?vue&type=template&id=a1c603de"
import script from "./GastronomyList.vue?vue&type=script&lang=js"
export * from "./GastronomyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__